<div class="chat-block" *ngIf="messages.length && showContent" @fadeIn>
  <div class="title-block">
    <div class="title">
      <div class="icon">
        <img src="assets/images/chat-history-icon.svg" alt="icon" />
      </div>
      <div class="text">Chat History</div>
    </div>
    <div class="close">
      <img tooltip="Close" (click)="closeChatBox()" src="assets/images/chat-history-close.svg" alt="icon" />
    </div>
  </div>
  <div class="conversation-block">
    <div *ngFor="let message of messages">
      <!-- Update: Checking 'Sender' instead of 'Bot' and 'User' -->
      <div class="bot-msg-block"
        *ngIf="message.Sender === 'bot' || message.Sender === 'system' || message.Sender === 'summary'">
        <!-- <img alt="Chatbot Image" class="chat-bot-profile" src="assets/images/chatbotmsgicon.svg" /> -->
        <img alt="Chatbot Image" class="chat-bot-profile" [src]="botProfilePic" />
        <div class="bot-msg">
          <p class="bot-date-time">{{ formatChatHistoryDate(message.Timestamp) }}</p> <!-- Update: Using 'Timestamp' -->
          <markdown class="message-content" [data]="formatNumbersInString(message?.Text ?? '')"></markdown>
        </div>
      </div>
      <div class="user-msg-block" *ngIf="message.Sender === 'user'">
        <div class="user-msg">
          <p class="user-date-time">{{ formatChatHistoryDate(message.Timestamp) }}</p>
          <markdown class="message-content" [data]="formatNumbersInString(message?.Text ?? '')"></markdown>
        </div>
        <img alt="User Image" class="chat-user-profile" [src]="userProfilePic" />
      </div>
    </div>
    <!-- 
    <div class="bot-msg-block alignment-table-block" *ngIf="isSummarizationLoaded">
      <img alt="Chatbot Image" class="chat-bot-profile" src="assets/images/chatbotmsgicon.svg" />

      <div class="table-msg-bubble">
        <p class="bot-date-time" >
          {{ formatChatHistoryDate(summarizationTimestamp) }}
        </p>

        <div class="p-table-wrapper">
          <p-table [value]="summarizationData" class="conv-summary-table">
            <ng-template pTemplate="header">
              <tr>
                <th>Log/<br>Update</th>
                <th>Reason</th>
                <th class="width50">Issue ID</th>
                <th class="width200">Issue Statement</th>
                <th class="width200">Issue Description</th>
                <th class="width200">Current State</th>
                <th class="width200">Business Impact</th>
                <th>Impact Area</th>
                <th>Severity</th>
                <th>Revenue Impact <div class="hinting">(in Million$)</div>
                </th>
                <th>Margin Impact <div class="hinting">(in Million$)</div>
                </th>
                <th class="width50">FTE</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <tr>
                <td>{{ common.getIssueType(rowData.flag) }}</td>
                <td>{{ getReasonText(rowData.reason_id) }}</td>
                <td>{{ rowData.issue_id }}</td>
                <td class="text-left">
                  <div class="scroll100">{{ rowData.risk_statement }}</div>
                </td>
                <td class="text-left">
                  <div class="scroll100">{{ rowData.risk_description }}</div>
                </td>
                <td class="text-left">
                  <div class="scroll100">{{ rowData.current_state }}</div>
                </td>
                <td class="text-left">
                  <div class="scroll100">{{ rowData.business_impact }}</div>
                </td>
                <td>{{ getImpactAreaText(rowData.impact_id) }}</td>
                <td>{{ getSeverityText(rowData.risk_severity) }}</td>
                <td>{{ rowData.revenue_impact }}</td>
                <td>{{ rowData.margin_impact }}</td>
                <td>{{ rowData.fte }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="12" class="text-left empty-msg-cell">
                  No issues were summarized in this check-in.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div> -->

    <div class="bot-msg-block alignment-table-block" *ngIf="isSummarizationLoaded">
      <!-- <img alt="Chatbot Image" class="chat-bot-profile" src="assets/images/chatbotmsgicon.svg" /> -->
      <img alt="Chatbot Image" class="chat-bot-profile" [src]="botProfilePic" />

      <div class="table-msg-bubble">
        <p class="bot-date-time">
          {{ formatChatHistoryDate(summarizationTimestamp) }}
        </p>

        <div class="p-table-wrapper">
          <p-table [value]="summarizationData" class="conv-summary-table">
            <ng-template pTemplate="header">
              <tr>
                <th>Log/<br>Update</th>
                <th>Reason</th>
                <th class="width50">Issue ID</th>
                <th class="width200">Issue Statement</th>
                <th class="width200">Issue Description</th>
                <th class="width200">Current State</th>
                <th class="width200">Business Impact</th>
                <th>Impact Area</th>
                <th>Severity</th>
                <th>Revenue Impact <div class="hinting">(in Million$)</div>
                </th>
                <th>Margin Impact <div class="hinting">(in Million$)</div>
                </th>
                <th class="width50">FTE</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              <tr>
                <td>{{ common.getIssueType(rowData.flag) }}</td>
                <td>{{ getReasonText(rowData.reason_id) }}</td>
                <td>{{ rowData.issue_id }}</td>
                <td class="text-left">
                  <div class="scroll100">{{ rowData.risk_statement }}</div>
                </td>
                <td class="text-left">
                  <div class="scroll100">{{ rowData.risk_description }}</div>
                </td>
                <td class="text-left">
                  <div class="scroll100">{{ rowData.current_state }}</div>
                </td>
                <td class="text-left">
                  <div class="scroll100">{{ rowData.business_impact }}</div>
                </td>
                <td>{{ getImpactAreaText(rowData.impact_id) }}</td>
                <td>{{ getSeverityText(rowData.risk_severity) }}</td>
                <td>{{ rowData.revenue_impact }}</td>
                <td>{{ rowData.margin_impact }}</td>
                <td>{{ rowData.fte }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="12" class="text-left empty-msg-cell">
                  No issues were summarized in this check-in.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>